module.exports = __webpack_public_path__ + "img/germany.be27f4eb.svg";